module.exports = __webpack_public_path__ + "static/media/cis.b1c84e0c.jpg";